module.exports = __webpack_public_path__ + "static/media/carousel3.702736c0.jpg";